import Grid from '@components/Grid';
import Link from '@components/UI/Link';
import Heading from '@components/UI/Typography/Heading';
import Paragraph from '@components/UI/Typography/Paragraph';

import { useRouter } from 'next/router';
import React from 'react';

const Categories = ({ categories }) => {
    const { pathname } = useRouter();

    return (
        <Grid
            xs='1'
            sm='2'
            md='3'
            g={ 6 }
            pt={ 12 }
        >
            { categories.map(category => (
                <Link
                    key={ category.id }
                    href={ `${ pathname/*.replace('/', '')*/ }/${ category.slug }` }
                    mix={ { 'help-center__category': true } }
                >
                    { /* eslint-disable-next-line @next/next/no-img-element */ }
                    {category.banner && <img
                        src={ category.banner }
                        alt={ category.title }
                    />}

                    <Heading
                        tag='h3'
                        color='neutral_900'
                    >
                        { category.title }
                    </Heading>

                    <Paragraph
                        tap='p'
                        size='lg'
                    >
                        { category.template }
                    </Paragraph>
                </Link>
            )
            ) }
        </Grid>
    );
};

export default Categories;
